import React from "react";
import { Modal, ModalBody } from "reactstrap";
import continueRegistrationImg from "../../assets/img/custom/continueRegistration.avif";

const ManagerRequirementsModal = ({ isOpen, toggle, onAccept }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      {/* Close button */}
      <button
        onClick={toggle}
        style={{
          position: "absolute",
          top: "10px",
          right: "14px",
          background: "none",
          border: "none",
          fontSize: "24px",
          fontWeight: "bold",
          color: "#555",
          cursor: "pointer",
          zIndex: 10,
          lineHeight: 1,
        }}
        aria-label="Close"
      >
        &times;
      </button>

      <ModalBody style={{ padding: "32px" }}>
        <img
          src={continueRegistrationImg}
          alt="Continue Registration"
          onClick={onAccept}
          style={{
            width: "100%",
            display: "block",
            cursor: "pointer",
            borderRadius: "8px",
          }}
        />
      </ModalBody>
    </Modal>
  );
};

export default ManagerRequirementsModal;
